export default "__VITE_ASSET__Db$cJ6zC__"